import React, { useState } from 'react';
import { faqs } from '../../data/mock';
import { SectionEyebrow, SectionTitle, Reveal } from './UI';
import { Plus, Minus } from 'lucide-react';

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section id="faq" className="bg-white">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-4">
            <Reveal>
              <SectionEyebrow>Good To Know</SectionEyebrow>
              <SectionTitle className="mt-6">Frequently Asked.</SectionTitle>
              <p className="mt-6 text-neutral-600 font-light">Everything you might need before your arrival. Our concierge is available around the clock for anything else.</p>
            </Reveal>
          </div>
          <div className="md:col-span-7 md:col-start-6">
            <ul className="divide-y divide-neutral-200 border-t border-b border-neutral-200">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <li key={f.q}>
                    <button
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      className="w-full flex items-start gap-6 justify-between py-6 md:py-7 text-left"
                    >
                      <span className="font-serif text-lg md:text-2xl text-neutral-900 leading-snug">{f.q}</span>
                      <span className="mt-1 shrink-0 w-8 h-8 border border-neutral-300 flex items-center justify-center">
                        {open ? <Minus className="w-4 h-4" strokeWidth={1.25} /> : <Plus className="w-4 h-4" strokeWidth={1.25} />}
                      </span>
                    </button>
                    <div className={`grid transition-all duration-500 ease-out ${open ? 'grid-rows-[1fr] opacity-100 pb-6 md:pb-8' : 'grid-rows-[0fr] opacity-0'}`}>
                      <div className="overflow-hidden">
                        <p className="text-neutral-600 font-light max-w-2xl leading-relaxed">{f.a}</p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
